export const getCountryUrl = () => '/business/countries';
export const getStatesUrl = (countryCode: string) => `/business/countries/${countryCode}/states`;
